var React = require('react');

function Ellipsis (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.6663 9.23013C12.3456 9.23013 12.8967 8.67901 12.8967 7.99971C12.8967 7.32042 12.3456 6.76987 11.6663 6.76987C10.9876 6.76987 10.4365 7.32042 10.4365 7.99971C10.4365 8.67901 10.9876 9.23013 11.6663 9.23013ZM8.04028 9.23013C8.71957 9.23013 9.27069 8.67901 9.27069 7.99971C9.27069 7.32042 8.71957 6.76987 8.04028 6.76987C7.36155 6.76987 6.81043 7.32042 6.81043 7.99971C6.81043 8.67901 7.36155 9.23013 8.04028 9.23013ZM5.35701 7.99971C5.35701 8.67901 4.80589 9.23013 4.12659 9.23013C3.4473 9.23013 2.89675 8.67901 2.89675 7.99971C2.89675 7.32042 3.4473 6.76987 4.12659 6.76987C4.80589 6.76987 5.35701 7.32042 5.35701 7.99971Z","fill":"#1C232B"}));
}

Ellipsis.displayName = "Ellipsis";

Ellipsis.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Ellipsis;

Ellipsis.default = Ellipsis;
